"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMaterializedViewProcessWorklease = exports.isMaterializedViewEvaluateWorklease = exports.isMaterializedViewDataAccessorArray = exports.isMaterializedViewDataAccessor = exports.isMaterializedViewRefreshConfig = exports.isMaterializedViewDataConfig = void 0;
const MaterializedView_1 = require("../types/MaterializedView");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isMaterializedViewDataConfig = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: MaterializedView_1.DataConfig.ConfigSchema,
    typeguardName: 'isMaterializedViewDataConfig',
});
exports.isMaterializedViewRefreshConfig = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: MaterializedView_1.RefreshConfig.ConfigSchema,
    typeguardName: 'isMaterializedViewRefreshConfig',
});
exports.isMaterializedViewDataAccessor = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: MaterializedView_1.DataConfig.DataAccessorSchema,
    typeguardName: 'isMaterializedViewDataAccessor',
});
exports.isMaterializedViewDataAccessorArray = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: MaterializedView_1.DataConfig.DataAccessorSchema,
    typeguardName: 'isMaterializedViewDataAccessorArray',
});
exports.isMaterializedViewEvaluateWorklease = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: MaterializedView_1.EvaluateWorklease.OptionsSchema,
    typeguardName: 'isMaterializedViewEvaluateWorklease',
});
exports.isMaterializedViewProcessWorklease = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: MaterializedView_1.ProcessWorklease.OptionsSchema,
    typeguardName: 'isMaterializedViewProcessWorklease',
});
//# sourceMappingURL=materializedView.js.map